import { useOnboarding } from '../../context/OnboardingContext';
import { applyStyles } from '../../utils/styleUtils';
import { getImageUrl } from '../../utils/imageUrl';
import { useChoiceSelection } from '../../hooks/useChoiceSelection';

const GridChoiceElement = ({ element }) => {
    const { replaceTemplates } = useOnboarding();
    const { selectedValue, handleSelect } = useChoiceSelection(element);

    const style = applyStyles(element);
    const options = element.options || [];
    const elementsPerRow = element.elementsPerRow ?? 2;
    const gridStyle = {
        display: 'grid',
        gridTemplateColumns: `repeat(${elementsPerRow}, 1fr)`,
        gap: '12px',
    };

    if (!options.length) return null;

    return (
        <div className="grid-choice-container" style={{ ...style, ...gridStyle }}>
            {options.map((option, index) => (
                <button
                    key={index}
                    className={`grid-choice-card ${selectedValue === option.value ? 'selected' : ''}`}
                    onClick={() => handleSelect(option)}
                >
                    <div className="grid-choice-image">
                        {option.image ? (
                            <img
                                src={getImageUrl(replaceTemplates(option.image))}
                                alt=""
                                onError={(e) => { e.target.style.display = 'none'; }}
                            />
                        ) : (
                            <div className="grid-choice-placeholder" />
                        )}
                    </div>
                    <div
                        className="grid-choice-button"
                        style={{ backgroundColor: option.buttonColor || '#87CEEB' }}
                    >
                        <span>{replaceTemplates(option.text)}</span>
                        {option.symbol && <span className="grid-choice-symbol">{option.symbol}</span>}
                    </div>
                </button>
            ))}
        </div>
    );
};

export default GridChoiceElement;
